module.exports = __webpack_public_path__ + "img/home.02d83ef8.svg";